/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useTranslation } from 'react-i18next';
import firebase from '../../firebase/firebase';

const Footer = () => {
  const { t } = useTranslation();

  const downloadPDF = async (fileName) => {
    const fileUrl = await firebase.getPDFLink(fileName);
    window.location.href = fileUrl;
  };

  return (
    <footer className="footer">
      <div className="footer-col-2">
        <h5>
          Uilpi &copy;&nbsp;
          {new Date().getFullYear()} - {t('copyrightMessage')} {' - '}
          {firebase.clientLocation === 'Italia' && <span>IT</span>}
          {firebase.clientLocation === 'Svizzera' && <span>CH</span>} {' | '}
          <a
            className="footer-link"
            onClick={() => downloadPDF('PrivacyCookiePolicy.pdf')}
          >
            {'Privacy \u0026 Cookie Policy'}
          </a>{' '}
          {' | '}
          <a
            className="footer-link"
            onClick={() => downloadPDF('TermsConditions.pdf')}
          >
            Terms and Conditions
          </a>
        </h5>
      </div>
    </footer>
  );
};

export default Footer;
